import decimal from "decimal.js";

let service = {};

let types = [{
  symbol: "XXC",
  name: "XXC",
  compression: 2,
}, {
  symbol: "SGD",
  name: "Singapore Dollars",
  compression: 2
}, {
  name: '',
  compression: 0,
  symbol: 'PASS'
}
]
let maps = {}
types.forEach(currency => {
  maps[currency.symbol] = currency;
})

let compress = (amount, currency, fixed) => {
  if (!amount) return 0;
  if (!currency) currency = "XXC";
  amount = decimal(amount);
  const nPow = maps[currency]?.compression || 0;
  let result = amount.times(decimal(10).pow(-nPow));
  if (fixed !== 0) fixed = fixed || 2;
  return result.toFixed(fixed);
}

let uncompress = (amount, currency) => {
  if (!amount) return 0;
  if (!currency) currency = "XXC";
  amount = decimal(amount);
  const nPow = maps[currency]?.compression || 0;
  let result = amount.times(decimal(10).pow(nPow));
  return result.toFixed();
}

service.compress = compress;
service.uncompress = uncompress;
service.types = types;
service.maps = maps;

export default service;

